export default {
  'ArtistReviewSection.title': { en: 'Reviews', fr: 'Commentaires' },
  'ArtistReviewSection.loadMore': { en: 'Load More', fr: 'Charger plus' },
};
